import { isIdentityApiError } from '@identity/application/errors';

/**
 * The wait a rate limited failure named, as an observability tag. It is a number of seconds and
 * nothing else, so there is no personal data to keep out of it.
 */
export const retryAfterAttributes = (error: unknown): { 'iam.retryAfterSeconds'?: number } => {
  if (!isIdentityApiError(error) || typeof error.retryAfterSeconds !== 'number') return {};

  return { 'iam.retryAfterSeconds': error.retryAfterSeconds };
};
